(function () {
    let contentObserver = null;
    let debounceTimer = null;

    function checkCartAndToggle(shadowRoot) {
        fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
                const hasSubscription = cart.items.some((item) => item.selling_plan_allocation);
                const outsideUK = window.storeCountry !== 'GB';
                const shouldHide = outsideUK || hasSubscription;

                shadowRoot.querySelectorAll('[role="progressbar"]').forEach((bar) => {
                    const wrapper = bar.closest('div.px-drawer');
                    if (wrapper) wrapper.style.display = shouldHide ? 'none' : '';
                });
            })
            .catch((err) => console.error('Cart check failed:', err));
    }

    function attachDrawerObserver(drawer, shadowRoot) {
        const itemsList = drawer.querySelector('section[role="list"]');
        const target = itemsList || drawer; // fallback if selector ever stops matching

        contentObserver = new MutationObserver(() => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => checkCartAndToggle(shadowRoot), 200);
        });

        contentObserver.observe(target, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        hideImmediately(shadowRoot);
        checkCartAndToggle(shadowRoot);
    }

    function hideImmediately(shadowRoot) {
        shadowRoot.querySelectorAll('[role="progressbar"]').forEach((bar) => {
            const wrapper = bar.closest('div.px-drawer');
            if (wrapper) wrapper.style.display = 'none';
        });
    }

    function attachDrawerWatcherInShadow(shadowRoot) {
        const shadowObserver = new MutationObserver((mutations) => {
            const drawer = shadowRoot.querySelector('#cart-drawer');

            if (drawer && !drawer.dataset.watching) {
                drawer.dataset.watching = 'true';
                attachDrawerObserver(drawer, shadowRoot);
            }

            mutations.forEach((mutation) => {
                mutation.removedNodes.forEach((node) => {
                    if (node.id === 'cart-drawer' || node.querySelector?.('#cart-drawer')) {
                        if (contentObserver) {
                            contentObserver.disconnect();
                            contentObserver = null;
                        }
                    }
                });
            });
        });

        shadowObserver.observe(shadowRoot, { childList: true, subtree: true });

        // catch the case where the drawer already exists at attach time
        const existingDrawer = shadowRoot.querySelector('#cart-drawer');
        if (existingDrawer && !existingDrawer.dataset.watching) {
            existingDrawer.dataset.watching = 'true';
            attachDrawerObserver(existingDrawer);
        }
    }

    function waitForHost(callback) {
        const existing = document.getElementById('recharge-storefront-experiences__cart-drawer');
        if (existing) {
            callback(existing);
            return;
        }

        const hostObserver = new MutationObserver(() => {
            const host = document.getElementById('recharge-storefront-experiences__cart-drawer');
            if (host) {
                hostObserver.disconnect();
                callback(host);
            }
        });

        hostObserver.observe(document.body, { childList: true, subtree: true });
    }

    waitForHost((host) => {
        if (host.shadowRoot) {
            attachDrawerWatcherInShadow(host.shadowRoot);
        } else {
            console.warn('Host found but shadowRoot inaccessible');
        }
    });
})();